import * as tslib_1 from "tslib";
var CODE = 'ExpiredPassword';
var ExpiredPasswordError = /** @class */ (function (_super) {
    tslib_1.__extends(ExpiredPasswordError, _super);
    function ExpiredPasswordError() {
        var _this = _super.call(this, CODE) || this;
        _this['error'] = { code: CODE };
        return _this;
    }
    return ExpiredPasswordError;
}(Error));
export { ExpiredPasswordError };
